import styled from 'styled-components/native';
import { themes } from '../../../design/colors';

export const TextTitlePage = styled.Text`
  color: ${themes.colors.black};
  font-weight: bold;
  font-size: 22px;
  margin-top: 20px;
  margin-bottom: 30px;
`;

export const ButtonAddRoute = styled.TouchableOpacity`
  background-color: ${themes.colors.primary};
  margin-top: 30px;
  height: 50px;
  border-radius: 5px;
`;

export const TextAddRoute = styled.Text`
  color: ${themes.colors.white};
  flex: 1;
  text-align: center;
  top: 15px;
  font-weight: bold;
  font-size: 16px;
`;

export const ContainerButton = styled.View`
  margin-bottom: 30px;
`;
